import FormFieldAPI from './form_field_api';
import { FormAPI } from 'lecom-api';
import { ChartActions } from 'chart/reflux/chart_store';

/**
 * @class LabelFormFieldAPI
 * @extends FormFieldAPI
 */
class ChartFormFieldAPI extends FormFieldAPI {

	/**
	 * @constructor
	 * @param {*} param0
	 */
	constructor({ id, storeId, formId, gridId, applyMode, isGridField = false }) {
		super({ id, storeId, formId, gridId, applyMode, isGridField });
	}

	/**
	 *
	 */
	loadChartData() {
		const storeEvents = this.storeClass.events;

		ChartActions.loadChartData(this.id);
		return this._buildEventPromise(storeEvents.CHART_LOAD, storeEvents.CHART_LOAD_ERROR);
	}

	/**
	 *
	 * @param {*} chartData
	 */
	chartData(chartData) {
		if(chartData === undefined)
			return this.get('chartData');

		return this._updateChartData(chartData);
	}

	/**
	 * @private
	 * @param {*} chartData
	 */
	_updateChartData(chartData) {
		const storeEvents = this.storeClass.events;

		ChartActions.updateChartData(this.id, chartData);
		return this._buildEventPromise(storeEvents.CHART_UPDATE);
	}
}

export default ChartFormFieldAPI;
